import type { Breakpoint } from '@mui/system';
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';

import { PageContextProvider, usePageContext } from '@contexts/page-context';

import MainWrapper from '@views/Records/Common/MainWrapper';

interface AdminManagementLayoutProps extends React.PropsWithChildren {
  title?: string;
  maxContentWidth?: Breakpoint;
  loading?: boolean;
}

function AdminManagementLayout({
  children,
  maxContentWidth,
  loading,
  title,
}: AdminManagementLayoutProps) {
  const { title: ctxTitle, setTitle } = usePageContext();

  React.useEffect(() => {
    if (title) {
      setTitle(title);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  return (
    <MainWrapper
      loading={loading}
      friendlyName={ctxTitle}
      title={ctxTitle}
      maxContentWidth={maxContentWidth}
    >
      <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
        {children}
      </ErrorBoundary>
    </MainWrapper>
  );
}

export default function WithProvider(props: AdminManagementLayoutProps) {
  return (
    <PageContextProvider>
      <AdminManagementLayout {...props} />;
    </PageContextProvider>
  );
}
